module.exports = __webpack_public_path__ + "img/cert-aaa.5c92cd81.png";